export type ClinicalFocusFields = {
  ClinicalFocusName: {
    value: string;
  };
};

export type ClinicalFocus = {
  // displayName: string;
  // id: string;
  name: string;
  //url: string;
  fields: ClinicalFocusFields;
};
